import api from './api';

const usersService = {
  list(params = {}) {
    return api.get('/users', { params });
  },
  listBasic(params = {}) {
    return api.get('/users/basic', { params });
  },
  getById(id) {
    return api.get(`/users/${id}`);
  }
};

export default usersService;